import {match} from 'ts-pattern';

import {always} from 'ramda';

import {ContextTarget} from '@dms/api/core';
import {EntityResourceIds} from '@dms/api/shared';

/**
 * Converts an EntityResourceId to its corresponding ContextTarget
 * Returns null if no mapping exists for the given EntityResourceId
 */
export const convertEntityResourceIdToContextTarget = (
  entityResourceId: EntityResourceIds | string
): ContextTarget | null =>
  match<EntityResourceIds | string, ContextTarget | null>(entityResourceId)
    .with(EntityResourceIds.businessCase, always('business-case'))
    .with(EntityResourceIds.serviceCase, always('service-case'))
    .with(EntityResourceIds.vehicle, always('vehicle'))
    .with(EntityResourceIds.rentalOrder, always('rental-order'))
    .with(EntityResourceIds.customer, always('customer'))
    .with(EntityResourceIds.serviceOrder, always('service-case-order'))
    .with(EntityResourceIds.serviceOrderReturn, always('service-order-return'))
    .with(EntityResourceIds.serviceOrderIssues, always('service-order-issue-note'))
    .with(EntityResourceIds.directSales, always('direct-sale'))
    .with(EntityResourceIds.directSale, always('direct-sale'))
    .with(EntityResourceIds.tireOrder, always('tire-order'))
    .with(EntityResourceIds.receiveNote, always('warehouse-receipt-note'))
    .with(EntityResourceIds.receiveNoteCorrection, always('warehouse-issue-note-correction'))
    .with(EntityResourceIds.deliveryNote, always('warehouse-issue-note'))

    // EntityResourceIds that don't have corresponding ContextTarget
    .with(EntityResourceIds.interest, always(null))
    .with(EntityResourceIds.checkout, always(null))
    .with(EntityResourceIds.employee, always(null))
    .with(EntityResourceIds.task, always(null))
    .with(EntityResourceIds.vehicleAudit, always(null))
    .with(EntityResourceIds.fastTrackIssues, always(null))
    .otherwise(always(null));
